/* OLVENIQ Maison — minimal behaviour layer */
(function () {
  // sticky header shadow
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // variant select -> price + availability
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var select = root.querySelector('select[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var btn = root.querySelector('[data-add-btn]');
    if (!select) return;
    var update = function () {
      var opt = select.options[select.selectedIndex];
      if (priceEl && opt.dataset.price) priceEl.innerHTML = opt.dataset.price;
      if (btn) {
        var unavailable = opt.dataset.available === 'false';
        btn.disabled = unavailable;
        btn.textContent = unavailable ? btn.dataset.soldOut : btn.dataset.addText;
      }
    };
    select.addEventListener('change', update);
    update();
  });

  // quantity steppers
  document.querySelectorAll('.qty-input').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = parseInt(input.value || '1', 10);
        v += b.dataset.step === 'up' ? 1 : -1;
        input.value = Math.max(1, v);
      });
    });
  });

  // close open <details> drawers on outside click
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[open].nav-drawer, details[open].search-toggle').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();
